export function isBirthCert(value) {
  return value.length >= 9
}
